import STORE from '../STORE';
import { API } from '@/utils/api';

const { actions } = STORE.modules.trial;
const { mutations: rootMutations } = STORE;

export default {
  namespaced: true,
  actions: {
    [actions.copyTrial]: async ({ dispatch }, { trial_id, newTrialName }) => {
      try {
        console.log('await response');
        let response = await API.get(`trials/${trial_id}/copy?name=${newTrialName}`);

        return response.data;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('failed', e.response);
      }
    },
  },
};
